var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PerformanceSummary',{attrs:{"start-date":_vm.startDate,"end-date":_vm.endDate,"dimension":_vm.dynamicDimension,"metric":_vm.metric}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }